import { ArrowLeft, Sparkles, UserCheck } from 'lucide-react';
import { useEffect } from 'react';
import { PageShell } from './layout/PageShell';
import { ShareTalentfunnBlock } from './ShareTalentfunnBlock';

interface GigsComingPageProps {
  onBack: () => void;
}

export function GigsComingPage({ onBack }: GigsComingPageProps) {
  useEffect(() => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  }, []);

  return (
    <div className="min-h-screen flex flex-col bg-white xl:bg-gradient-to-br xl:from-purple-50 xl:via-pink-50 xl:to-orange-50">
      <PageShell className="pt-page-safe-sm pb-android-pwa-doc xl:max-w-2xl xl:mx-auto xl:px-4 xl:px-8 xl:pt-5 xl:pb-24">
        <div className="pt-5 xl:bg-white xl:rounded-3xl xl:shadow-xl xl:border-2 xl:border-purple-100 xl:p-8">
          <button
            onClick={onBack}
            className="flex items-center gap-2 text-purple-600 hover:text-purple-700 mb-6 px-4 xl:px-0 transition-colors"
          >
            <ArrowLeft className="w-5 h-5" />
            <span>Tilbake</span>
          </button>

          <h1 className="text-2xl sm:text-3xl font-semibold text-gray-900 mb-4 px-4 xl:px-0 bg-gradient-to-r from-purple-600 to-pink-600 bg-clip-text text-transparent text-center">
            Her kommer oppdragene!
          </h1>

          <div className="space-y-6 px-4 xl:px-0 text-gray-700 leading-relaxed">
            <p className="text-center">
              Snart vil du få tilgang til en feed med muligheter der du kan melde interesse med ett klikk.
            </p>

            <section>
              <h2 className="text-lg font-semibold text-purple-900 mb-3 flex items-center gap-2">
                <Sparkles className="w-5 h-5 text-purple-600" />
                Hva skjer i neste fase?
              </h2>
              <ul className="space-y-2 list-disc pl-5">
                <li>Arbeidsgivere legger ut alt fra små til store prosjekter.</li>
                <li>Vis interesse for oppdrag, og bli oppdaget av arbeidsgivere.</li>
              </ul>
            </section>

            <div className="bg-gradient-to-r from-purple-50 to-pink-50 rounded-xl p-5 border-2 border-purple-200">
              <p className="font-medium text-purple-900 mb-1 flex items-center gap-2">
                <UserCheck className="w-5 h-5 text-purple-600" />
                Ditt viktigste steg nå
              </p>
              <p className="text-gray-700">
                Sørg for at profilen din er 100% komplett. Jo bedre profil, jo lettere er det for arbeidsgivere å velge nettopp deg!
              </p>
            </div>

            <ShareTalentfunnBlock />
          </div>
        </div>
      </PageShell>
    </div>
  );
}
